// extracted by mini-css-extract-plugin
export default {"ff_viewer_icon":"ViewerIcon_ff_viewer_icon__oFSsw"};